
/**
 * 返回去掉时分秒的日期字符串
 */
function datetimeStrToDateStr(datetimeStr) {
    return /\d{4}-\d{1,2}-\d{1,2}/g.exec(datetimeStr)
}
/**
 * 返回最后一个sep之后的字符串
 */
function getLast(str,sep) {
    return str.substring(str.lastIndexOf(sep)+1)
}

export default {datetimeStrToDateStr,getLast
};